// extracted by mini-css-extract-plugin
export default {"token":"Menu_token__xp3DV","link":"Menu_link__OdW5+","button":"Menu_button__GJKs2"};